<script setup>
import AccountSettingsAccount from '~/views/pages/account-settings/AccountSettingsAccount.vue'
import AccountSettingsSecurity from '~/views/pages/account-settings/AccountSettingsSecurity.vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const { t } = useI18n()
const route = useRoute()

const activeTab = computed({
  get: () => route.params.tab,
  set: () => route.params.tab,
})

// tabs
const tabs = [
  {
    title: 'user.profile',
    icon: 'tabler-users',
    tab: 'account',
  },
  {
    title: 'user.security.title',
    icon: 'tabler-lock',
    tab: 'security',
  },
]

definePage({
  name: 'pages-profile-account-settings-tab',
  meta: { navActiveLink: 'pages-profile-account-settings-tab' }
})
</script>

<template>
  <div>
    <VTabs v-model="activeTab" class="v-tabs-pill">
      <VTab v-for="item in tabs" :key="item.icon" :value="item.tab"
        :to="{ name: 'pages-profile-account-settings-tab', params: { tab: item.tab } }">
        <VIcon size="20" start :icon="item.icon" />
        {{ $t(item.title) }}
      </VTab>
    </VTabs>

    <VWindow v-model="activeTab" class="mt-6 disable-tab-transition" :touch="false">
      <!-- Account -->
      <VWindowItem value="account">
        <AccountSettingsAccount />
      </VWindowItem>

      <!-- Security -->
      <VWindowItem value="security">
        <AccountSettingsSecurity />
      </VWindowItem>

    </VWindow>
  </div>
</template>
